import { Component, Input } from '@angular/core';
import { LucideAngularModule, BadgeCheck, Gift } from 'lucide-angular';
import { CurrencyPipe } from '@angular/common';
import { EventProductItemModel } from '@app/events/shared/event-product-item.model';

@Component({
  selector: 'app-product-item-price-column',
  templateUrl: './product-item-price-column.component.html',
  imports: [LucideAngularModule, CurrencyPipe],
})
export class ProductItemPriceColumnComponent {
  @Input('item') protected item!: EventProductItemModel;
  protected readonly BadgeCheck = BadgeCheck;
  protected readonly Gift = Gift;

  get displayPrice(): number {
    return this.item.calculated_price !== undefined && this.item.calculated_price !== null
      ? this.item.calculated_price
      : 0;
  }

  get discountedPrice(): number {
    return this.item.discounted_price ?? 0;
  }

  get discountAmount(): number {
    return this.displayPrice - this.discountedPrice;
  }

  get isOfferItem(): boolean {
    return this.item.is_offer_item === true;
  }

  get isVenueHireProduct(): boolean {
    return this.item.product?.name?.toLowerCase() === 'venue hire';
  }

  get showDiscontinuedIndicator(): boolean {
    return this.item.is_discontinued === true && !this.isVenueHireProduct;
  }

  get showMinSpendIndicator(): boolean {
    return this.item.product?.is_minimum_spend === true;
  }
}
